import { useEffect, useState } from "react";
import { api, errMsg } from "@/lib/api";

const COLS = [["visit", "Visits"], ["start", "Starts"], ["finish", "Finishes"], ["feel_calmer", "Calmer"], ["feel_same", "Same"], ["feel_tense", "Tense"],
  ["share", "Shares"], ["shared_visit", "From shares"], ["pricing", "Pricing clicks"], ["checkout", "Checkouts"], ["purchases", "Purchases"]];

// Anonymous per-tool totals for the free calm tools
export const ToolsStats = () => {
  const [days, setDays] = useState(7);
  const [rows, setRows] = useState(null);
  const [err, setErr] = useState("");
  useEffect(() => { setRows(null); api.get("/admin/tools-stats", { params: { days } }).then((r) => setRows(r.data.tools)).catch((e) => setErr(errMsg(e))); }, [days]);
  return (
    <section className="mm-card p-5 mt-6" data-testid="admin-tools-stats">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div><h2 className="font-semibold text-lg">Calm Tools</h2><p className="text-xs text-mm-muted">Anonymous counts only. No names, emails, IPs or device IDs.</p></div>
        <div className="flex gap-1 rounded-full bg-mm-primary/10 p-1">
          {[7, 30].map((d) => <button key={d} onClick={() => setDays(d)} className={`rounded-full px-3 py-1 text-xs font-semibold ${days === d ? "bg-mm-primary text-white" : "text-mm-primary"}`} data-testid={`admin-tools-days-${d}`}>{d} days</button>)}
        </div>
      </div>
      {err && <p className="text-sm text-mm-error mt-3">{err}</p>}
      {rows && (
        <div className="overflow-x-auto mt-4">
          <table className="w-full text-sm" data-testid="admin-tools-table">
            <thead><tr className="text-left text-xs text-mm-muted"><th className="py-2 pr-3">Tool</th>{COLS.map(([, l]) => <th key={l} className="py-2 px-2 text-right whitespace-nowrap">{l}</th>)}</tr></thead>
            <tbody>
              {rows.map((r) => (
                <tr key={r.tool} className="border-t border-mm-primary/10" data-testid={`admin-tools-row-${r.tool}`}>
                  <td className="py-2 pr-3 font-semibold whitespace-nowrap">{r.name}</td>
                  {COLS.map(([k]) => <td key={k} className="py-2 px-2 text-right tabular-nums">{r[k] || 0}</td>)}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </section>
  );
};
